import styled from 'styled-components';

const Container = styled.div.withConfig({
  componentId: 'mega-board-item_container',
  displayName: 'MegaBoardItem.Container',
})``;

export const MegaBoardItemStyle = {
  Container,
};
